module.exports = __webpack_public_path__ + "static/tokr-video-197f0085420e915a0954e667f6043d83.mp4";